import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-950'>
      <div className='flex flex-col items-center gap-4'>
        <Loader2 className='w-12 h-12 text-blue-600 animate-spin' />
        <p className='text-sm text-gray-600 dark:text-gray-400'>Carregando...</p>
      </div>
    </div>
  );
}
